import { fromJS, OrderedMap } from 'immutable';
import * as ActionTypes from '../constants/ActionTypes';

import Contact from '../records/contact';
import Merchant from '../records/merchant';
import Vendor from '../records/vendor';
import Place from '../records/place';
import Hour from '../records/hour';
import Image from '../records/image';
import SupplyInvite from '../records/supply-invite';
import SupplyNode from '../records/supply-node';
import Post from '../records/post';
import Schedule from '../records/schedule';
import Deal from '../records/deal';

const models = {
  contacts: Contact,
  hours: Hour,
  merchant: Merchant,
  vendors: Vendor,
  places: Place,
  images: Image,
  supplyInvites: SupplyInvite,
  supplyNodes: SupplyNode,
  posts: Post,
  schedules: Schedule,
  deals: Deal
}

const entitiesState = fromJS({
  contacts: new OrderedMap(),
  hours: new OrderedMap(),
  merchant: new OrderedMap(),
  vendors: new OrderedMap(),
  places: new OrderedMap(),
  images: new OrderedMap(),
  tags: new OrderedMap(),
  supplyInvites: new OrderedMap(),
  supplyNodes: new OrderedMap(),
  posts: new OrderedMap(),
  following: new OrderedMap(),
  schedules: new OrderedMap(),
  deals: new OrderedMap(),
  vouchers: new OrderedMap()
});

function setState(state, newState) {
  return state.merge(newState);
}

export function entities(state = entitiesState, action) {
  switch(action.type) {
    case ActionTypes.CLEAR_ENTITIES:
      if (action.payload) {
        return setState(state, state.set(action.payload, entitiesState.get(action.payload)));
      }
      return entitiesState;

    case ActionTypes.CLEAR_ENTITY:
      if (!action.data) return state;
      return setState(state, state.deleteIn([action.entity ? action.entity : action.data.type, action.data.id]));

    case ActionTypes.RECEIVE_ENTITIES:
      if (action.data.length < 1) return state;

      action.data.map(record => state = setState(state, state.setIn([record.type, record.id], models[record.type] ?
        new models[record.type](record.type !== 'merchant' ? fromJS(record).flatten(true) : fromJS(record)) :
        fromJS(record).flatten(true))));
      return state;

    case ActionTypes.RECEIVE_ENTITY:
      return setState(state, state.setIn([action.data.type, action.data.id], models[action.data.type] ?
        new models[action.data.type](action.data.type !== 'merchant' ? fromJS(action.data).flatten(true) : fromJS(action.data)) :
        fromJS(action.data).flatten(true)));

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/entities.js